var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',_vm._l((_vm.realTech),function(tech,index){return _c('v-chip',{key:index,staticClass:"blue darken-1 ma-1 chips"},[_vm._v(" "+_vm._s(tech)+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }